import React, {useContext} from 'react';
import {observer} from "mobx-react";
import MobXContext from "../../../app/mobx/MobXContext";
import MenuInput from "../Input/MenuInput/MenuInput";

const propTypes = {};
const defaultProps = {};

const ConfiguratorMenu = () => {
	const {configuratorStore} = useContext(MobXContext);
	return (
		<div className="configurator__inputs">
			<MenuInput menu={configuratorStore.mainMenu} allowSubMenuItems={true}/>
		</div>
	);
};

ConfiguratorMenu.propTypes = propTypes;
ConfiguratorMenu.defaultProps = defaultProps;

export default observer(ConfiguratorMenu);
